/* Maison Velour — Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  /* ── CART DRAWER ── */
  const overlay = document.querySelector('.cart-drawer-overlay');
  const drawer = document.querySelector('.cart-drawer');
  const openBtns = document.querySelectorAll('[data-open-cart]');
  const closeBtn = document.querySelector('.cart-drawer-close');

  function openCart() {
    if (overlay) overlay.classList.add('open');
    if (drawer) drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (overlay) overlay.classList.remove('open');
    if (drawer) drawer.classList.remove('open');
    document.body.style.overflow = '';
  }
  openBtns.forEach(btn => btn.addEventListener('click', openCart));
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  /* ── ACCORDION ── */
  document.querySelectorAll('.accordion-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const isOpen = this.classList.contains('open');
      document.querySelectorAll('.accordion-btn').forEach(b => {
        b.classList.remove('open');
        if (b.nextElementSibling) b.nextElementSibling.classList.remove('open');
      });
      if (!isOpen) {
        this.classList.add('open');
        if (content) content.classList.add('open');
      }
    });
  });

  /* ── SIZE SELECTOR ── */
  document.querySelectorAll('.size-btn:not(.sold-out)').forEach(btn => {
    btn.addEventListener('click', function () {
      this.closest('.size-grid').querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ── QTY CONTROLS ── */
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.closest('.qty-wrap').querySelector('.qty-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'plus') val = Math.min(val + 1, 99);
      if (this.dataset.action === 'minus') val = Math.max(val - 1, 1);
      input.value = val;
    });
  });

  /* ── GALLERY THUMBS ── */
  document.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      this.closest('.gallery-thumbs').querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      const main = document.querySelector('.gallery-main');
      const src = this.querySelector('img')?.src;
      if (main && src) {
        const mainImg = main.querySelector('img');
        if (mainImg) mainImg.src = src;
      }
    });
  });

  /* ── HEADER SCROLL ── */
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', () => {
    if (header) {
      if (window.scrollY > 40) {
        header.style.borderBottomColor = 'rgba(232,224,213,0.2)';
      } else {
        header.style.borderBottomColor = 'rgba(232,224,213,0.1)';
      }
    }
  });

  /* ── MOBILE MENU ── */
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileOverlay = document.querySelector('.mobile-nav-overlay');

  function openMobileNav() {
    if (mobileNav) mobileNav.classList.add('open');
    if (mobileOverlay) mobileOverlay.classList.add('open');
    if (menuToggle) menuToggle.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (mobileNav) mobileNav.classList.remove('open');
    if (mobileOverlay) mobileOverlay.classList.remove('open');
    if (menuToggle) menuToggle.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', () => {
    mobileNav && mobileNav.classList.contains('open') ? closeMobileNav() : openMobileNav();
  });
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);

  /* ── SEARCH TOGGLE ── */
  const searchToggle = document.querySelector('.header-search-toggle');
  const searchBar = document.querySelector('.header-search-bar');
  const searchClose = document.querySelector('.header-search-close');
  const searchInput = document.querySelector('.header-search-input');

  function openSearch() {
    if (!searchBar) return;
    searchBar.classList.add('open');
    searchBar.setAttribute('aria-hidden', 'false');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    setTimeout(() => { if (searchInput) searchInput.focus(); }, 320);
  }
  function closeSearch() {
    if (!searchBar) return;
    searchBar.classList.remove('open');
    searchBar.setAttribute('aria-hidden', 'true');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
  }

  if (searchToggle) searchToggle.addEventListener('click', () => {
    searchBar && searchBar.classList.contains('open') ? closeSearch() : openSearch();
  });
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeSearch(); closeMobileNav(); }
  });

});
